import React, { useMemo } from 'react';

// Styles & Assets
import styles from './ResultsPollPatientDialog.module.css';

// Services
import { dateFormat } from '../../../services/parseDates';
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useState, useEffect } from 'react';
import useHttp from '../../../hooks/useHttp';
import { useTranslation } from 'react-i18next';

// Components
import PollQuestions from '../../UI/PollQuestions/PollQuestions';
import ErrorSpinnerWrapper from '../../UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';

// Interfaces
import { PatientInquiriesValues, PatientInquiryAnswer, Poll, PollQuestion } from '../../../interfaces/Poll';
interface IPatientInquiriesValues extends PatientInquiriesValues {
    answers: PatientInquiryAnswer[]
    inquiry: Poll
}

const ResultsPollPatientDialog: React.FC<{
    patient_id: number | undefined,
    patientInquiriesID: PatientInquiriesValues['id'],
    setShowDialog: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ patient_id, patientInquiriesID, setShowDialog }) => {

    const { t } = useTranslation();

    const { isLoading: loadingAnswers, error: errorAnswers, sendRequest: getAnswers } = useHttp<IPatientInquiriesValues>();

    const [patientInquiryAnswers, setPatientInquiriesAnswers] = useState<IPatientInquiriesValues | null>(null);

    useEffect(() => {
        getAnswers({
            url: getEnvironmentApiUrl() + `patient/${patient_id}/inquiries_values/${patientInquiriesID}`,
        }, (assignedInquiry) => setPatientInquiriesAnswers(assignedInquiry));
    }, []);

    const questionsWithAnswer: PollQuestion[] = useMemo(() => {
        const orderedAnswers = patientInquiryAnswers?.answers
            .sort((a, b) => (a.answer?.question?.order ?? -1) > (b.answer?.question?.order ?? -1) ? 1 : 0) ?? [];
        return orderedAnswers?.map(a => {
            const question = a.answer?.question;
            const answer = a.answer;
            if (!answer) return { ...question, answers: [] };
            answer.description = answer.description || a.free_description;
            delete answer.question;
            return { ...question, answers: [answer] };
        });
    }, [patientInquiryAnswers]);


    return (
        <div className='dialog'>
            <h1 className='dialogTitle'>{patientInquiryAnswers?.inquiry.name ?? '-'}</h1>
            <h2 className='dialogSubTitle'>{t('answered_on')} {dateFormat(patientInquiryAnswers?.filled_date)}</h2>
            <div className={styles.questionsContainer}>
                <ErrorSpinnerWrapper
                    loading={loadingAnswers}
                    error={errorAnswers}
                >
                    <PollQuestions questions={questionsWithAnswer} />
                </ErrorSpinnerWrapper>
            </div>
            <div className={styles.buttonContainer}>
                <button onClick={() => setShowDialog(false)} className={`button ${styles.buttonClose}`}>
                    {t('close')}
                </button>
            </div>
        </div>
    );
};

export default ResultsPollPatientDialog;